import { createRoutine } from 'redux-saga-routines';

export const addComment = createRoutine('ADD_COMMENT_TO_MOMENT');
export const clearMomentsData = createRoutine('CLEAR_MOMENTS_DATA');
export const createMoment = createRoutine('CREATE_MOMENT');
export const createMomentFilter = createRoutine('CREATE_MOMENT_FILTER');
export const deleteMomentFilter = createRoutine('DELETE_MOMENT_FILTER');
export const removeMoment = createRoutine('REMOVE_MOMENT');
export const stopSyncingMoments = createRoutine('STOP_SYNCING_MOMENTS');
export const stopSyncingMomentsConfig = createRoutine('STOP_SYNCING_MOMENTS_CONFIG');
export const syncMoments = createRoutine('SYNC_MOMENTS');
export const syncMomentsConfig = createRoutine('SYNC_MOMENTS_CONFIG');
export const toggleCommentBlockOnMoment = createRoutine('TOGGLE_COMMENT_BLOCK_ON_MOMENT');
export const toggleMomentConfigSetting = createRoutine('TOGGLE_MOMENT_CONFIG_SETTING');
export const updateMomentFilter = createRoutine('UPDATE_MOMENT_FILTER');
export const updateMoment = createRoutine('UPDATE_MOMENT');

